import Keycloak from 'keycloak-js';

export default new Keycloak('/keycloak.json');
